export const DepartureLocationEnum = {
  Amsterdam: {
    Code: "AMS",
    DisplayName: "Amsterdam, (AMS), Nederland",
  },
  All_AIRPORTS: "All Airports"
};
